import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSpring, animated } from '@react-spring/web';
import './CapitecRiseConfirmationModal.css';

const CapitecRiseConfirmationModal = ({ isOpen, onClose }) => {
  const reduced =
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const overlayAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    config: { tension: 90, friction: 26, mass: 1.2 },
  });

  const cardAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'scale(1)' : 'scale(0.8)',
    config: { tension: 90, friction: 18, mass: 1.5 },
    immediate: reduced,
  });

  useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = event => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <animated.div
      className="capitec-rise-confirm-overlay"
      style={overlayAnimation}
      onClick={onClose}
      role="presentation"
    >
      <animated.div
        className="capitec-rise-confirm-modal"
        style={cardAnimation}
        role="dialog"
        aria-modal="true"
        aria-labelledby="capitec-rise-confirm-title"
        onClick={event => event.stopPropagation()}
      >
        <h2 id="capitec-rise-confirm-title" className="capitec-rise-confirm-title">
          Capitec rise program application
        </h2>

        <div className="capitec-rise-confirm-body">
          <p>
            Thank you for applying to the Capitec Rise Program, powered by EDC!
          </p>
          <p>
            To complete your application and be considered for the program,
            you&apos;ll need to register as a creator on EDC if you haven&apos;t
            already.
          </p>
          <p>
            Please head over to{' '}
            <a
              href="https://edcsquared.io"
              target="_blank"
              rel="noopener noreferrer"
              className="capitec-rise-confirm-link"
            >
              edcsquared.io
            </a>{' '}
            and complete your creator registration to move forward with your
            application.
          </p>
        </div>

        <button
          type="button"
          className="capitec-rise-btn capitec-rise-btn--primary"
          onClick={onClose}
        >
          Close
        </button>
      </animated.div>
    </animated.div>,
    document.body
  );
};

export default CapitecRiseConfirmationModal;
